module.exports = __webpack_public_path__ + "static/media/newapplicationsbtn.861a06d7.svg";